import React from "react";
import { useSelector } from "react-redux";
import CustomSpinner from "./CustomSpinner";

const MasterLoader = () => {
  const { loading } = useSelector((state) => state.globalLoader);
  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <CustomSpinner color="dark" size="3rem" />
        </div>
      )}
    </>
  );
};

export default MasterLoader;
